import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import Paragraph from '../../atoms/paragraphs/Paragraph';
import Pagination from '../../molecules/grids/Pagination';

const HistoryComponent = ({ intl, ...props }) => {
  const {
    config,
    data,
    pagination,
    actions,
    historyPage,
    onPageChange,
    historyTitle,
    initialExpanded = false,
  } = props;
  const [isExpanded, setIsExpanded] = useState(initialExpanded);
  const cssClass = isExpanded ? 'expanded' : 'collapsed';

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className='--history p-4'>
      <div className='d-flex flex-column w-100'>
        <div
          className='d-flex flex-row justify-content-between w-100'
          onClick={toggleExpand}
        >
          <Paragraph className='d-flex text-header h4'>
            {historyTitle}
          </Paragraph>
          <span className={`d-flex button-dropdown ${cssClass}`}></span>
        </div>
        {isExpanded && (
          <div className='--history-table'>
            <div className='sep-light mt-2'></div>
            <div className='d-flex flex-column fw-bold mt-4'>
              <div className='d-flex flex-row --history-header'>
                {Object.keys(config).map((configElement, index) => (
                  <div
                    key={'header-' + index}
                    className={`d-flex header-${configElement} justify-content-center ${config[configElement].headerClassName}`}
                  >
                    <Paragraph className='text-header'>
                      {config[configElement].headerValue}
                    </Paragraph>
                  </div>
                ))}
              </div>
              <div className='sep-light'></div>
              {data.map((element, element_index) => (
                <div
                  key={'row-' + element_index}
                  className={`d-flex flex-row mt-1 ${
                    actions.clickable
                      ? '--history-item-clickable'
                      : '--history-item'
                  }`}
                  onClick={
                    actions.onAction ? () => actions.onAction(element) : null
                  }
                >
                  {Object.keys(config).map((element_key, element_key_index) => (
                    <div
                      key={element_key + '-' + element_key_index}
                      className={`d-flex justify-content-center ${config[element_key].rowClassName} ${
                        typeof config[element_key].paragraphClassName ===
                        'function'
                          ? config[element_key].paragraphClassName(element)
                          : config[element_key].paragraphClassName
                            ? config[element_key].paragraphClassName
                            : 'text-paragraph'
                      }`}
                    >
                      {config[element_key].formatValue
                        ? config[element_key].formatValue(element[element_key])
                        : element[element_key] +
                          (config[element_key].suffix
                            ? config[element_key].suffix
                            : '')}
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className='d-flex justify-content-center mt-3'>
              <Pagination
                className='history-pagination'
                page={historyPage}
                numberOfPages={pagination.total_pages}
                getDocumentsPage={onPageChange}
              ></Pagination>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default injectIntl(HistoryComponent);
